module.exports = {"652325100":"奇台镇","652325101":"老奇台镇","652325102":"半截沟镇","652325103":"吉布库镇","652325104":"东湾镇","652325105":"西地镇","652325106":"碧流河镇","652325107":"三个庄子镇","652325108":"西北湾镇","652325202":"坎尔孜乡","652325203":"五马场乡","652325204":"古城乡","652325205":"乔仁乡","652325206":"七户乡","652325208":"塔塔尔乡","652325503":"兵团奇台农场","652325504":"兵团农六师北塔山牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652325.json
// module id = 3216
// module chunks = 0